import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import anime from "animejs";
import {
    swiperinit
} from "./swiper"
import {
    modal_idinit,
    modal_idreset
} from "./modal-id"
import {
    accinit
} from "./acc"
import {
    sminit
} from "./scrollmagic"
import {
    rellaxinit
} from "./paralax"
import {
    topmovesvginit
} from "./top-move-svg"
import {
    topjustimginit
} from "./top-justimg"
import { onclicksInit } from './onclicks';
import { tabInit } from './tab';

//header・body書き換え
const replaceHead = function (data) {
    const head = document.head;
    const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    const newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    const removeHeadTags = [
        "meta[name='keywords']", "meta[name='description']", "meta[property^='og']", "meta[name^='twitter']", "meta[itemprop]", "link[itemprop]", "link[rel='prev']", "link[rel='next']", "link[rel='canonical']"
    ].join(',');

    const headTags = head.querySelectorAll(removeHeadTags)

    for (let i = 0; i < headTags.length; i++) {
        head.removeChild(headTags[i]);
    }

    const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for (let i = 0; i < newHeadTags.length; i++) {
        head.appendChild(newHeadTags[i]);
    }

    //bodyクラス変更
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
        match = regexp.exec(data.next.html);
    if (!match || !match[1]) {
        // If no body class, remove it
        document.body.setAttribute("class", "");
    } else {
        // Set the new body class
        document.body.setAttribute("class", match[1]);
    }
}

// ページ遷移時に実行する内容

function everyMove() {
    swiperinit()
    modal_idinit()
    modal_idreset()
    accinit()
    sminit()
    rellaxinit()
    topmovesvginit()
    topjustimginit()
    onclicksInit()
    tabInit()
}

everyMove()

barba.hooks.before((data) => {
    //ハンバーガー閉じる
    header.classList.remove("is-on");
    document.documentElement.style.overflowY = "auto"
})

barba.hooks.enter((data) => {
    replaceHead(data);
    document.querySelector(".mv__hide").style.display = "none"
})

barba.hooks.after((data) => {
    everyMove()
    if (location.hash != "") {
        let offset = window.innerWidth > 1024 ? window.innerWidth * -0.1 : window.innerWidth * -0.21
        let scrollvalue = document.querySelector(location.hash).getBoundingClientRect().top + offset
        window.scrollTo({
            top: scrollvalue
        })
    }
})

barba.use(barbaPrefetch);

barba.init({
    transitions: [{
        name: 'page-transition',
        sync: true,
        leave: function (data) {
            const done = this.async();
            data.current.container.classList.add("js-barba__leave");
            data.current.container.style.top = -(window.scrollY) + "px";
            window.scrollTo(0, 0)
            anime.timeline().add({
                targets: data.current.container,
                opacity: [1, 0],
                easing: "easeInOutQuad",
                duration: 200,
                // delay: 200,
                complete: function () {
                    done();
                }
            })
            anime.timeline().add({
                targets: document.querySelectorAll(".header__list")[0],
                background: ["rgba(0, 165, 190,1)", "rgba(0, 165, 190,0)"],
                easing: "easeInOutQuad",
                duration: 200,
                complete: function () {
                    done();
                }
            })
        },
        enter: function (data) {
            const done = this.async();
            data.next.container.classList.add("js-barba__enter");
            anime.timeline().add({
                targets: data.next.container,
                opacity: [0, 1],
                easing: "easeInOutQuad",
                duration: 600,
                delay: 200,
                complete: function () {
                    done();
                    data.next.container.classList.remove("js-barba__enter");
                }
            })
            anime.timeline().add({
                targets: document.querySelectorAll(".header__list")[0],
                background: ["#rgba(0, 165, 190,0)", "rgba(0, 165, 190,1)"],
                easing: "easeInOutQuad",
                duration: 600,
                delay: 300,
                complete: function () {
                    done();
                }
            })
        }
    }],
})